import { Phone, Mail } from 'lucide-react';
import React from 'react';

export default function ContactBanner() {
  return (
    <section className="bg-[#d2a391] text-white  pt-0.5 " id="contact">
      {/* Mapka Google */}
      <div className="relative w-full h-[400px]">
      <iframe
        title="Mapa Lesko - Gabinet Psychoterapii"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2533.8733148385896!2d22.3309412!3d49.4710875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473c71a69a1f26a3%3A0xd1edc9ed9aa1efba!2sRynek%2011%2C%2038-600%20Lesko!5e0!3m2!1spl!2spl!4v1718283600000!5m2!1spl!2spl"
        className="w-full h-full border-0 filter grayscale"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      ></iframe>
      </div>
    </section>
  );
}
